<template>
  <el-dialog title="选择用户" :visible.sync="dialogVisible" :before-close="handleClose" class="user-selectbox dialogPaddingTop0">
    <el-container>
      <el-row :gutter="24" class="width100 margin0">
        <el-col :span="6" class="border-r" style="display:none">
          <el-tree
            ref="tree"
            node-key="id"
            :props="{
                  label: 'name',
                  children: 'zones',
                  isLeaf: 'leaf'
                }"
            :load="loadNode"
            show-checkbox
            check-strictly
            :default-expanded-keys="defaultExpandedKeys"
            :expand-on-click-node="false"
            lazy
          ></el-tree>
        </el-col>
        <el-col :span="24" class="paddingRight0">
          <el-form :inline="true" :model="searchdata" class="form-inline" size="mini"  @submit.native.prevent>
            <el-form-item  class="paddingLeft0">
              <el-input v-model="searchdata.data.name" placeholder="用户姓名" @keyup.enter.native="searchTableData"></el-input>
            </el-form-item>
            <el-form-item  class="paddingLeft0">
              <el-input v-model="searchdata.data.loginno" placeholder="用户账号" @keyup.enter.native="searchTableData"></el-input>
            </el-form-item>
            <el-form-item  class="paddingLeft0">
                <el-select v-model="searchdata.departmentid" filterable class="el-select-w">
                  <el-option
                    label="请选择部门"
                    value="">
                    </el-option>
                  <el-option v-for="item in depts.datas" 
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            <el-form-item>
              <el-button @click="searchTableData" type="primary" plain >{{$t('query')}}</el-button>
              <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData.datas" 
            @selection-change='selectUser'
            max-height="350" 
            highlight-current-row
            size="small">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="用户名称"></el-table-column>
            <el-table-column prop="loginno" label="账号"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>
            <el-table-column prop="telephone" label="手机"></el-table-column>
            <!-- <el-table-column prop="defaultDepartment" label="部门id"></el-table-column> -->
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="searchTableData"
            :current-page.sync="searchdata.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchdata.pagelines"
            layout="prev, pager, next, total, sizes"
            background
            :total="tableData.rowCount?tableData.rowCount:0"
          ></el-pagination>
        </el-col>
      </el-row>
        
    </el-container>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel" size="small" type="primary" plain>{{$t('cancel')}}</el-button>
      <el-button type="primary" @click="onOk" size="small">{{$t('confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ["visible",'roleId', 'updateBatchUser', "applicationId", "docIdSelection"],

  data() {
    return {
      defaultExpandedKeys: [],
      node:[],
      resolve:function(){},
      isFirst:true,
      roleData: {},
      onlineData: {},
      searchdata: {
        domainid:this.$route.query.domainid,
        departmentid: "",
        currpage: 1,
        pagelines: 10,
        orderby: "",
        data:{
          name: "",
          loginno: "",
          superiorname: "",
          roleid: "",
        }
      },
      tableData: [],
      tableDatabyRole: [],
      searchall: false,
      checkUser:[],
      depts:[],//部门列表
      deptIdsdefault:[],//用户默认部门id
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    this.searchTableData();
    this.loadNode(this.node,this.resolve);
    this.getDepts();
  },
  methods: {
    //获取部门列表
    getDepts(){
      this.$api.getSubDepartments({superiorid:"",...this.searchdata,pagelines:100000}, {
        onSucess: resp => {
          this.depts = resp.data.data;
        }
      });
    },
    //勾选用户
    selectUser(selection){
      this.checkUser=[];
      this.deptIdsdefault=[];
      if(selection.length>0){
        selection.forEach(elm=>{
          this.checkUser.push(elm.id)
          this.deptIdsdefault.push(elm.defaultDepartment)
        })
      }
    },
    onOk() {
      let checkDept = this.$refs.tree.getCheckedNodes();
      let checkedDept=[];
      checkDept.forEach(elm=>{
        checkedDept.push(elm.id)
      })
      // 流程面板中更新指定审批人
      if(this.updateBatchUser){
        let data = {
          "userIds":this.checkUser,
          "docs": this.docIdSelection
        }
        if(data.userIds.length<1){
          this.$message.error("必须选择用户");
          return false;
        }
        this.$api.updateBatchUser(data, {
          onSucess: resp => {
            if(resp.data.data){
              this.$message({
                showClose: true,
                message: resp.data.data,
                type: "error"
              });
            } else{
              this.$message({
                showClose: true,
                message: '更新成功',
                type: "success"
              });
              this.dialogVisible = false;
              this.$parent.searchTableData()
            }
          }
        })
      }else{
        let data={
          "roleId":this.roleId,
          // "deptIds":checkedDept,
          "deptIds":this.deptIdsdefault,//默认部门id
          "userIds":this.checkUser
        }
        // if(data.deptIds.length<1 ){
        //   this.$message.error("必须选择部门");
        //   return false;
        // }
        if(data.userIds.length<1){
          this.$message.error("必须选择用户");
          return false;
        }
        
        this.checkUser.forEach((item,index)=>{
              let dataNew={
               "roleId":this.roleId,
               "deptIds":this.deptIdsdefault[index].split(","),//默认部门id
               "userIds":this.checkUser[index].split(",")//string.split(",") 字符串转数组
              }
              this.$api.batchUser(dataNew, { //批量改完循环单个
                onSucess: resp => {
                  if(resp.data.errcode==0){
                    this.$message({
                      showClose: true,
                      message: this.$t('msg_add_success'),
                      type: "success"
                    });
                    this.dialogVisible = false;

                  }
                  else{
                    this.$message({
                      showClose: true,
                      message: "添加失败",
                      type: "error"
                    });
                  }
                }
              });
          })
         }
    },
    onCancel() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    resetSearchTableData(){
      this.searchdata={
        domainid: this.$route.query.domainid,
        departmentid: "",
        currpage: 1,
        pagelines: 10,
        orderby: "",
        data:{
          name: "",
          loginno: "",
          superiorname: "",
          roleid: "",
        }
      };
      this.searchTableData();
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        if(this.isFirst){
          this.isFirst=false;
          this.node=node;
          this.resolve=this.resolve;
        }
        this.$api.getRootDepartment(this.$route.query.domainid, {
          onSucess: resp => {
            let rootDepartment = resp.data.data;
            resolve([rootDepartment]);
            this.defaultExpandedKeys.push(rootDepartment.id);
          }
        });
      }
      if (node.level >= 1) {
        this.$api.getSubDepartmentNodes(this.$route.query.domainid, node.key, {
          onSucess: resp => {
            let subdepts = resp.data.data;
            resolve(subdepts);
          }
        });
      }
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    searchTableData() {
      this.searchdata.domainid = this.$route.query.domainid;
      this.searchdata.data.roleid = "";
      this.$api.getUsers(this.searchdata, {
        onSucess: resp => {
          this.tableData = resp.data.data;
        }
      });
    },
  }

};
</script>

<style>


</style>